import Button from "./UI/Button";
import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "@/firebase/firebaseConfig";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";
import { FirebaseError } from "firebase/app";
import { useTheme } from "@/utils/theme-context";

const Reset = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email.toLowerCase());
      setSuccessMessage(
        "Ссылка на сброс пароля отправлена. Если данный email зарегистрирован, вы получите письмо. Пожалуйста, проверьте свою почту. Не забудьте проверить папку спам.",
      );
      setErrorMessage("");
    } catch (error) {
      if (error instanceof FirebaseError) {
        setErrorMessage(errorMessages[error.message] || errorMessages.default);
      } else {
        setErrorMessage(errorMessages.default);
      }
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  const { theme } = useTheme();

  return (
    <>
      <p className="authentication-box__title">Восстановить аккаунт </p>
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}
      {successMessage && (
        <p className="authentication-box__success"> {successMessage} </p>
      )}
      <label htmlFor="email">Email</label>
      <input
        className={`input  input--${theme} `}
        required
        value={email}
        id="email"
        name="email"
        type="email"
        placeholder="you@example.com"
        onChange={(event) => setEmail(event.target.value)}
      />

      <div className="authentication-box-buttons">
        {loading ? (
          <Button
            title="Отправка..."
            color="black"
            disabled
            onClick={handlePasswordReset}
          />
        ) : (
          <Button
            title="Отправить ссылку"
            color="black"
            onClick={handlePasswordReset}
          />
        )}

        <a className="authentication-box__link" href="/auth/sign-in">
          Вернуться на главную
        </a>
      </div>
    </>
  );
};

export default Reset;
